import {Axios} from '../axios/axios.js'
//获取列表
export const getAddressList = (e) => {
  return Axios({
    url:"/index.php/address/get_address_list",
    method:'put',
    data:e
  })
}
//新增
export const addNew = (e) => {
  return Axios({
    url:"/index.php/address/add_address",
    method:'put',
    data:e
  })
}
//编辑
export const EditNew = (e) => {
  return Axios({
    url:"/index.php/address/edit_address",
    method:'put',
    data:e
  })
}
//删除
export const deleteNew = (e) => {
  return Axios({
    url:"/index.php/address/del_address",
    method:'put',
    data:e
  })
}
//组织下拉数据
export const getOrgaList = (e) => {
  return Axios({
    url:"/index.php/Organization/get_drop_organization_list",
    method:'put',
    data:e
  })
}
//门店下拉数据
export const getSubOrgaList = (e) => {
  return Axios({
    url:"/index.php/Organization/get_drop_sub_organization_list",
    method:'put',
    data:e
  })
}
